"use client";
import { jsx as r } from "react/jsx-runtime";
import * as a from "@radix-ui/react-portal";
import { forwardRef as i } from "react";
const m = i((o, t) => /* @__PURE__ */ r(a.Root, { "data-slot": "portal", ...o, ref: t }));
m.displayName = "Portal";
export {
  m as Portal
};
